import {
    faChevronDown,
    faChevronUp,
    faCopy,
    faSave,
    faTimes
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { connect } from "react-redux";
import * as pages from "../../modules/pages/reducer";

function CrappyPaletteEditor({
    pageColors,
    palette,
    paletteModified,
    palettes,
    savePageColorsAsPalette,
    setPageColorAtIndex,
    setPageColorPalette,
    onClose
}) {
    return (
        <div
            style={{
                position: "fixed",
                left: "1rem",
                top: "1rem",
                zIndex: 999999,
                background: "white",
                border: "0.1rem solid black",
                borderRadius: "0.3rem",
                display: "flex",
                flexFlow: "column",
                padding: "1rem 3rem",
                boxShadow: "0.5rem 0.5rem 0.5rem rgba(0, 0, 0, 0.5)"
            }}
        >
            <button
                style={{
                    position: "absolute",
                    top: "0.5rem",
                    right: "0.5rem"
                }}
                onClick={() => {
                    if (paletteModified) {
                        const res = window.confirm(
                            `The changes you made to ${palette} will be discarded. Are you sure you want that?`
                        );
                        if (!res) {
                            return;
                        }
                        // reset the palette to the unmodified version
                        setPageColorPalette(palette);
                    }
                    onClose();
                }}
            >
                <FontAwesomeIcon icon={faTimes} size="lg" />
            </button>

            <h1
                style={{
                    marginBottom: "1rem",
                    fontWeight: "bold",
                    fontSize: "2rem"
                }}
            >
                This is a Secret! Keep Out!
            </h1>
            <select
                value={palette}
                style={{ marginBottom: "1rem" }}
                onChange={e => {
                    if (e.target.value === palette) {
                        return;
                    }
                    if (paletteModified) {
                        const res = window.confirm(
                            `The changes you made to ${palette} will be discarded. Are you sure you want that?`
                        );
                        if (!res) {
                            return;
                        }
                    }
                    return setPageColorPalette(e.target.value);
                }}
            >
                {Object.keys(palettes)
                    .sort()
                    .map(p => (
                        <option key={p} value={p}>
                            {p} {p === palette && paletteModified && "*"}
                        </option>
                    ))}
            </select>
            <ol
                style={{
                    listStyle: "none",
                    display: "flex",
                    flexFlow: "column",
                    alignItems: "stretch"
                }}
            >
                {pageColors.map((color, index, arr) => (
                    <li
                        key={color}
                        style={{
                            display: "flex",
                            flexFlow: "row nowrap",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "0.5rem",
                            padding: "0 3rem"
                        }}
                    >
                        <button
                            style={{ marginRight: "0.5rem" }}
                            disabled={index === 0}
                            onClick={() => {
                                const c1 = arr[index - 1];
                                const c2 = arr[index];
                                setPageColorAtIndex(index - 1, c2);
                                setPageColorAtIndex(index, c1);
                            }}
                        >
                            <FontAwesomeIcon icon={faChevronUp} size="lg" />
                        </button>
                        <div
                            style={{
                                display: "flex",
                                flexFlow: "row nowrap",
                                alignItems: "center"
                            }}
                            onClick={() => {
                                const result = window.prompt(
                                    "Enter the new color",
                                    color
                                );
                                if (!result || result === color) {
                                    return;
                                }
                                return setPageColorAtIndex(index, result);
                            }}
                        >
                            <div
                                style={{
                                    height: "2rem",
                                    width: "2rem",
                                    background: color,
                                    marginRight: "0.5rem",
                                    border: "0.1rem solid black"
                                }}
                            />
                            <p
                                style={{
                                    flex: 1,
                                    margin: 0,
                                    textTransform: "uppercase",
                                    fontSize: "1.4rem",
                                    fontFamily:
                                        "Menlo, Monaco, Consolas, monospace",
                                    textAlign: "left"
                                }}
                            >
                                {color}
                            </p>
                        </div>
                        <button
                            style={{ marginLeft: "0.5rem" }}
                            disabled={index === arr.length - 1}
                            onClick={() => {
                                const c1 = arr[index];
                                const c2 = arr[index + 1];
                                setPageColorAtIndex(index, c2);
                                setPageColorAtIndex(index + 1, c1);
                            }}
                        >
                            <FontAwesomeIcon icon={faChevronDown} size="lg" />
                        </button>
                    </li>
                ))}
            </ol>
            <div
                style={{
                    display: "flex",
                    flexFlow: "row nowrap",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}
            >
                <button
                    title="Save Palette to Local Storage"
                    disabled={!localStorage}
                    onClick={() => {
                        let message = "Enter a name for the palette";

                        while (true) {
                            const def = pages.isSystemPalette(palette)
                                ? `${palette} (copy)`
                                : palette;
                            const result = window.prompt(message, def);
                            if (!result) {
                                return;
                            }

                            if (pages.isSystemPalette(result)) {
                                message = `Oops. ${result} is a built-in palette. You can't overwrite it. Try a different name`;
                            } else {
                                return savePageColorsAsPalette(result);
                            }
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faSave} size="2x" />
                </button>
                <button
                    title="Copy Palette to Clipboard"
                    onClick={async () => {
                        const text = JSON.stringify(pageColors);
                        await navigator.clipboard.writeText(text);
                        window.alert(
                            `Copied the following palette colors to the clipboard: ${text}`
                        );
                    }}
                >
                    <FontAwesomeIcon icon={faCopy} size="2x" />
                </button>
            </div>
        </div>
    );
}

function mapStateToProps({ pages }) {
    return pages;
}

function mapDispatchToProps(dispatch) {
    return {
        setPageColorPalette: palette =>
            dispatch(pages.setPageColorPalette(palette)),
        setPageColorAtIndex: (index, color) =>
            dispatch(pages.setPageColorAtIndex(index, color)),
        savePageColorsAsPalette: paletteName =>
            dispatch(pages.savePageColorsAsPalette(paletteName))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CrappyPaletteEditor);



// WEBPACK FOOTER //
// ./src/components/Results/CrappyPaletteEditor.js